import { ENABLE_WHATSAPP_NOTIFICATION_REQUEST, ENABLE_WHATSAPP_NOTIFICATION_SUCCESS, ENABLE_WHATSAPP_NOTIFICATION_FAILURE, ENABLE_WHATSAPP_NOTIFICATION_RESET, } from "../../actions";
const initialState = {
    data: null,
    isLoading: false,
    error: null,
};
const EnableWhatsappNotificationreducer = (state = initialState, action) => {
    switch (action.type) {
        case ENABLE_WHATSAPP_NOTIFICATION_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case ENABLE_WHATSAPP_NOTIFICATION_SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, isLoading: false, error: null });
        case ENABLE_WHATSAPP_NOTIFICATION_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case ENABLE_WHATSAPP_NOTIFICATION_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, data: null, error: null });
        default:
            return state;
    }
};
export default EnableWhatsappNotificationreducer;
